import { createUniqueId, Show, type ParentComponent } from "solid-js";
import SeparatorLine from "../components/SeparatorLine";

type PropertySectionProps = {
  title?: string;
};

const PropertySection: ParentComponent<PropertySectionProps> = (props) => {
  const sectionId = `property-section-${createUniqueId()}`;

  return (
    <>
      <Show when={props.title}>
        <SeparatorLine orientation="horizontal" class="-mx-4 my-6" />
      </Show>
      <section aria-labelledby={sectionId}>
        <Show when={props.title}>
          <h3 id={sectionId} class="mb-3 text-medium-semibold text-primary">
            {props.title}
          </h3>
        </Show>
        <div class="flex flex-col gap-y-6">{props.children}</div>
      </section>
    </>
  );
};

export default PropertySection;
